import React, { ForwardedRef, forwardRef } from 'react'
import { Checkbox as AntCheckbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { CheckboxProps } from 'antd/lib/checkbox'
import cl from 'classnames'

import styles from './styles.module.scss'

// to replace interface from "(e: CheckboxChangeEvent) => void" to "(value: boolean) => void"
export interface CustomCheckboxProps extends Omit<CheckboxProps, 'onChange'> {
	onChange?: (value: boolean) => void
	disabled?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, CustomCheckboxProps>(
	({ className, onChange, checked, disabled, ...props }, ref: ForwardedRef<HTMLInputElement>) => {
		const onChangeEvent = (e: CheckboxChangeEvent) => onChange && onChange(e.target.checked)

		return (
			<AntCheckbox
				onChange={onChangeEvent}
				{...props}
				className={cl(styles.checkbox, className, { [styles.checked]: checked })}
				checked={checked}
				ref={ref}
				disabled={disabled}
			/>
		)
	}
)

export default Checkbox
